/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "/dashboard",
    name: "Dashboard",
    view: "Portfolio/Portfolio",
    meta: { layout: "view" },
  },
  {
    path: "/trader/dashboard",
    name: "TraderDashboard",
    view: "TraderDashboard/View",
    meta: { layout: "view" },
  },
  {
    path: "/connection/:id",
    name: "Investor Details",
    view: "Connections/View",
    meta: { layout: "view" },
  },
  {
    path: "/accounts",
    name: "My Accounts",
    view: "Accounts/List",
    meta: { layout: "view" },
  },
  {
    path: "/account/:id",
    name: "View Account",
    view: "Accounts/View",
    meta: { layout: "view" },
  },
  {
    path: "/rankings/:id?",
    name: "Top Funds",
    view: "Rankings/List",
    meta: { layout: "view" },
  },
  {
    path: "/ranking/:id",
    name: "View Fund",
    view: "Rankings/View",
    meta: { layout: "view" },
  },
  // {
  //   path: '/bots/:id?',
  //   name: 'Top Bots',
  //   view: 'Bots/List',
  //   meta: {layout: 'view'}
  // },
  // {
  //   path: '/traderbots/:id?',
  //   name: 'Trading Bots',
  //   view: 'TraderBots/List',
  //   meta: {layout: 'view'}
  // },
  // {
  //   path: '/traderbots/install/:id',
  //   name: 'Install Bot',
  //   view: 'TraderBots/Install',
  //   meta: {layout: 'view'}
  // },
  // {
  //   path: '/mybots/update/:id',
  //   name: 'Update Bot',
  //   view: 'TraderBots/Install',
  //   meta: {layout: 'view'}
  // },
  // {
  //   path: '/traderbots/mybot/:id',
  //   name: 'My Bot',
  //   view: 'TraderBots/View',
  //   meta: {layout: 'view'}
  // },
  // {
  //   path: '/traderbots/aumbot/:id',
  //   name: 'Aum Bot',
  //   view: 'TraderBots/View',
  //   meta: {layout: 'view'}
  // },
  {
    path: "/projects",
    name: "Projects",
    view: "Projects/List",
    meta: { layout: "view" },
  },
  {
    path: "/project/create",
    name: "New Project",
    view: "Projects/NewOrEdit",
    meta: { layout: "view" },
  },
  {
    path: "/project/:id/edit",
    name: "Edit Project",
    view: "Projects/NewOrEdit",
    meta: { layout: "view" },
  },
  {
    path: "/investors",
    name: "Investors",
    view: "Investors/List",
    meta: { layout: "view" },
  },
  {
    path: "/buycrypto",
    name: "Buy Crypto",
    view: "BuyCrypto/Moonpay",
    meta: { layout: "view" },
  },
  {
    path: "/invoices",
    name: "Invoices",
    view: "Invoices/List",
    meta: { layout: "view" },
  },
  {
    path: "/services",
    name: "Services",
    view: "Services/List",
    meta: { layout: "view" },
  },
  {
    path: "/invoice/:id",
    name: "View Invoice",
    view: "Invoices/View",
    meta: { layout: "view" },
  },
  {
    path: "/affiliates",
    name: "Affiliates",
    view: "Affiliates/Main",
    meta: { layout: "view" },
  },
  {
    path: "/profile",
    name: "Profile",
    view: "Profile/Profile",
    meta: { layout: "view" },
  },
  {
    path: "/security",
    name: "Security",
    view: "Security/View",
    meta: { layout: "view" },
  },
  // {
  //   path: "/wallets",
  //   name: "View Wallets",
  //   view: "Wallets/View",
  //   meta: { layout: "view" },
  // },
  // {
  //   path: "/wallets/verify/:id?",
  //   name: "AIV Wallet",
  //   view: "Wallets/Verify",
  //   meta: { layout: "view" },
  // },
  {
    path: "/calculator",
    name: "ROI Estimator",
    view: "Calculator/View",
    meta: { layout: "view" },
  },
  {
    path: "/merchants/buy/:symbol",
    name: "Buy AIV",
    view: "Merchants/View",
    meta: { layout: "view" },
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    view: "Subscriptions/View",
    meta: { layout: "view" },
  },
  {
    path: "/gateway/pay/:id",
    name: "Gateway Pay",
    view: "Gateway/Process",
    meta: { layout: "view" },
  },
  {
    path: "/thankyou/:id?",
    name: "ThankYou",
    view: "Invoices/ThankYou",
    meta: { layout: "view" },
  },

  // Auth Routes

  {
    path: "/register/:id?",
    name: "Register",
    view: "Auth/Register",
    meta: { layout: "view-auth" },
  },
  {
    path: "/verifyemail/:id",
    name: "Verify Email",
    view: "Auth/VerifyEmail",
    meta: { layout: "view-auth" },
  },
  {
    path: "/login",
    name: "Login",
    view: "Auth/Login",
    meta: { layout: "view-auth" },
  },
  {
    path: "/logout",
    name: "Logout",
    view: "Auth/Logout",
    meta: { layout: "view-auth" },
  },
  {
    path: "/resetpassword",
    name: "ResetPassword",
    view: "Auth/ResetPassword",
    meta: { layout: "view-auth" },
  },
  {
    path: "/newpassword/:id",
    name: "NewPassword",
    view: "Auth/NewPassword",
    meta: { layout: "view-auth" },
  },

  // Widget Routes
  {
    path: "/widget/rankings",
    name: "Widget Rankings",
    view: "Widgets/Rankings",
    meta: { layout: "view-widget" },
  },
];
